// RelatedProducts.js
import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import RetryableImage from "../retryableImage/RetryableImage";

import styled from 'styled-components';

const Relatedproduct = styled.div`
    text-align: start;
    background-color: #f4f4f4;
`;
const Heading = styled.h1`
    margin-left: 100px;
    margin-top: 0px;
    padding-top: 20px;
    @media (max-width: 480px) {
    padding-right: 20px;
    margin-right: 10px;
    width: 100%;
    text-align: center;
    margin-left: 0;
}
`;
const Carouselcontainers = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: auto;
    height: 350px;
`;
const Prevbutton = styled.button`
    position: static;
    margin-right: 8px;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 20px;
    color: ${window.ENV.GENERAL.TEXT_COLOR};
    background: transparent;
`;
const Nextbutton = styled.button`
    position: static;
    margin-left: 8px;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 20px;
    color: ${window.ENV.GENERAL.TEXT_COLOR};
    background: transparent;
`;

const ProductGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 0;
  justify-content: flex-start;
  transition: transform 0.5s ease;
  will-change: transform;

  @media (max-width: 1175px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* For Firefox */
  }

  @media (max-width: 1175px)::-webkit-scrollbar {
    display: none; /* For Chrome/Safari */
  }
`;

const ProductItem = styled.div`
  width: 250px;
  height: auto;
  border: 1px solid #ddd;
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.5s ease, box-shadow 0.5s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  /* Tablet: between 768px and 1024px */
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 290px;
    margin: 10px;
  }

  /* Large mobile: between 417px and 767px */
  @media (max-width: 767px) and (min-width: 417px) {
    width: 305px;
    margin-bottom: 15px;
  }

  /* Small mobile: 382px to 416px */
  @media (max-width: 416px) and (min-width: 383px) {
    width: 275px;
    margin-bottom: 15px;
  }

  /* Extra small mobile: up to 382px */
  @media (max-width: 382px) {
    width: 250px;
    margin-bottom: 15px;
  }
`;


const ProductImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
  margin-bottom: 10px;
 
  transition: transform 0.3s ease;

  /* Image hover effect */
  &:hover {
    transform: scale(1.05); /* Zoom effect */
  }
`;

const StyledRetryableImage = styled(RetryableImage)`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
  //margin-bottom: 10px;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const ProductName = styled.p`
  font-size: 1rem;
  color: #003063;
  margin: 0;
  font-weight: 500;
`;

const StyledNavLink = styled(NavLink)`
    margin-bottom: 10px; /* Adds space between the text and image */
  text-align: center;
  text-decoration: none; /* ✅ Remove quotes */
  
`;


const RelatedProduct = ({ relatedItems, nextSlide, prevSlide }) => {
  return (
    <Relatedproduct>
      <Heading>Related Products</Heading>
      <Carouselcontainers>
        <Prevbutton onClick={prevSlide}>
          <FaChevronLeft size={30} />
        </Prevbutton>
        <ProductGrid>
          {relatedItems && relatedItems.length > 0 ? (
            relatedItems.map((product, index) =>
              product ? (
                <NavLink
                  key={index}
                  to={`/category/${product.categoryName}/productdetails/${product.productId}`}
                  style={({ isActive }) => ({
                    textDecoration: "none",
                    color: isActive ? "#007bff" : "inherit", // Highlight active link
                  })}
                  onClick={() => console.log("Navigating to:", product)}
                >
                  <ProductItem>
                    {/* <ProductImage
                      src={`${window.ENV.SERVER_URL}${product.isometric_view}` || "default-image.jpg"}
                      alt={product.productId || "Unnamed Product"}
                    /> */}

                    <StyledRetryableImage
                      src={`${window.ENV.SERVER_URL}${product.isometric_view}` || "default-image.jpg"}
                      alt={product.productId || "Unnamed Product"}
                      maxRetries={window.ENV.MAX_RETRIES || 10}
                      retryDelay={window.ENV.RETRY_DELAY || 5000}
                    />

                    <StyledNavLink to={`/category/${product.categoryName}/productdetails/${product.productId}`}>
                      <ProductName>{product.productId || 'Unnamed Product'}</ProductName>
                    </StyledNavLink>
                  </ProductItem>
                </NavLink>
              ) : (
                <ProductItem key={index}>Loading...</ProductItem>
              )
            )
          ) : (
            <p>No related products available.</p>
          )}
        </ProductGrid>
        <Nextbutton onClick={nextSlide}>
          <FaChevronRight size={30} />
        </Nextbutton>
      </Carouselcontainers>
    </Relatedproduct>
  );
};

export default RelatedProduct;
